import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ properties, uploadStatus }) => {
  const total = properties?.length;
  const valid = properties?.filter(p => p?.address && p?.price && p?.bedrooms && p?.bathrooms && p?.type)?.length;
  const invalid = total - valid;
  const progress = total > 0 ? Math.round((valid / total) * 100) : 0;

  if (total === 0) return null;

  return (
    <div className="p-5 rounded-xl" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)' }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold text-sm">Upload Progress</h3>
        <span className="text-cyan-400 font-bold text-sm">{progress}% ready</span>
      </div>

      {/* Progress Bar */}
      <div className="w-full h-2 rounded-full mb-4" style={{ background: 'rgba(255,255,255,0.1)' }}>
        <div
          className="h-2 rounded-full transition-all duration-500"
          style={{ width: `${progress}%`, background: progress === 100 ? '#22C55E' : 'linear-gradient(90deg, #00D4FF, #7B2FFF)' }}
        />
      </div>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-3">
        <div className="text-center p-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.03)' }}>
          <p className="text-white font-bold text-xl">{total}</p>
          <p className="text-slate-400 text-xs">Total</p>
        </div>
        <div className="text-center p-3 rounded-lg" style={{ background: 'rgba(34,197,94,0.05)' }}>
          <p className="text-green-400 font-bold text-xl">{valid}</p>
          <p className="text-slate-400 text-xs">Valid</p>
        </div>
        <div className="text-center p-3 rounded-lg" style={{ background: 'rgba(239,68,68,0.05)' }}>
          <p className="text-red-400 font-bold text-xl">{invalid}</p>
          <p className="text-slate-400 text-xs">Errors</p>
        </div>
      </div>

      {/* Upload Status */}
      {uploadStatus && (
        <div className={`mt-4 flex items-center gap-2 p-3 rounded-lg ${
          uploadStatus === 'success' ? 'bg-green-400/10' :
          uploadStatus === 'uploading' ? 'bg-cyan-400/10' : 'bg-red-400/10'
        }`}>
          {uploadStatus === 'uploading' && <div className="w-4 h-4 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin" />}
          {uploadStatus === 'success' && <Icon name="CheckCircle" size={16} color="#22C55E" />}
          {uploadStatus === 'error' && <Icon name="XCircle" size={16} color="#EF4444" />}
          <p className={`text-sm font-medium ${
            uploadStatus === 'success' ? 'text-green-400' :
            uploadStatus === 'uploading' ? 'text-cyan-400' : 'text-red-400'
          }`}>
            {uploadStatus === 'uploading' && 'Uploading properties...'}
            {uploadStatus === 'success' && `${valid} properties published successfully!`}
            {uploadStatus === 'error' && 'Upload failed. Please fix errors and try again.'}
          </p>
        </div>
      )}

      {/* Error Guidance */}
      {invalid > 0 && (
        <div className="mt-3 p-3 rounded-lg" style={{ background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.15)' }}>
          <p className="text-red-400 text-xs font-medium mb-1">Fix required fields to proceed:</p>
          <p className="text-slate-400 text-xs">Address, Price, Bedrooms, Bathrooms, and Property Type are required for each listing.</p>
        </div>
      )}
    </div>
  );
};

export default ProgressTracker;
